<template>
  <v-overlay :value="showOverlay" width="80%">
    <v-progress-circular :width="7" indeterminate size="64" color="primary">
    </v-progress-circular>
  </v-overlay>
</template>
<script>
export default {
  data: () => ({}),
  props: {
    showOverlay: {
      type: Boolean,
      default: false,
    },
  },
  name: "Overlay",
};
</script>
